// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4180":"102b44a24a373f97c7fd","9356":"204b30e4032f373177ee"}[chunkId] + ".css";
};